import React, { useEffect } from 'react';
import { useWizard } from 'react-use-wizard';

import { useGraphRef } from 'src/app/graph/hooks/useGraphRef';
import {
  AddSubgraphForm,
  AddSubgraphFormProps,
} from 'src/app/graph/shared/addSubgraphForm/AddSubgraphForm';

import { AddVariantWizardFields } from './shared';

export const AddSchemaStep = ({
  onClose,
  setCurrentStep,
  hasManagedSubgraphs,
  ...formProps
}: {
  hasManagedSubgraphs: boolean;
  onClose: () => void;
  setCurrentStep: React.Dispatch<React.SetStateAction<number>>;
} & Omit<AddSubgraphFormProps<AddVariantWizardFields>, 'withSubgraphName'>) => {
  const { activeStep } = useWizard();
  useEffect(() => setCurrentStep(activeStep), [activeStep, setCurrentStep]);

  const graphRef = useGraphRef();
  if (!graphRef?.graphId) {
    return <div>GraphId needed to create variant</div>;
  }
  return (
    <div>
      <h2 className="text-lg font-semibold text-black">
        {`Add your new variant’s ${
          hasManagedSubgraphs ? 'first subgraph' : 'schema'
        }`}
      </h2>
      <div className="mb-4 mt-1 text-base text-secondary">
        {`Let’s start with a GraphQL API that will become your first ${
          hasManagedSubgraphs
            ? 'subgraph for this variant. You can always add additional subgraphs later.'
            : 'publish on this variant. You can always re-publish later.'
        }`}
      </div>
      <AddSubgraphForm {...formProps} withSubgraphName={hasManagedSubgraphs} />{' '}
    </div>
  );
};
